module.exports = __webpack_public_path__ + "static/media/3 12 Tulleord Brillter er feil.264fae29.mp3";